import { ClientOnly, createFileRoute } from "@tanstack/react-router";

import { MarketingNavbar } from "@/web/routes/-marketing/MarketingNavbar";
import { WillowMap } from "@/web/routes/explore/-WillowMap";
import {
  CatskillsPasswordGate,
  prefetchCatskillsGate,
} from "@/web/routes/explore/catskills/-passwordGate";
import { CATSKILLS_PROPERTIES } from "@/web/routes/explore/catskills/-data";

export const Route = createFileRoute("/explore/catskills/")({
  loader: async ({ context }) => {
    await prefetchCatskillsGate(context.queryClient);
  },
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <CatskillsPasswordGate>
      <div className="flex w-full flex-col overflow-x-clip">
        {/* Navbar depends on Clerk + scroll position — client-only to avoid SSR hangs. */}
        <ClientOnly>
          <MarketingNavbar solid />
        </ClientOnly>

        <main className="mx-auto flex w-full max-w-7xl flex-col gap-6 px-4 pt-24 pb-16">
          <header>
            <h1 className="withus-strong text-2xl">Explore // Catskills</h1>
            <p className="text-sm text-withus-dark-blue/60">
              Commercial real estate available in and around Catskill, NY.
            </p>
          </header>

          <WillowMap properties={CATSKILLS_PROPERTIES} />
        </main>
      </div>
    </CatskillsPasswordGate>
  );
}
